import React, { useEffect } from 'react';

import { mixpanelEvent } from '~/src/mixpanel';
import { FormErrors } from '~/src/root.types';
import { ErrorMessageBox } from './error-message.styles';
import { ErrorMessageProps } from './error-message.types';

export function ErrorMessage(props: ErrorMessageProps): JSX.Element {
  const { message, mixpanelAttribute, ...rest } = props;

  useEffect(() => {
    if (mixpanelAttribute && message === FormErrors.BUSINESS_EMAIL) {
      mixpanelEvent.track({ name: 'DemoRequestFailedDueNonBusinessEmail', props: { attribute: mixpanelAttribute } });
    }
  }, [message, mixpanelAttribute]);

  return (
    <ErrorMessageBox {...rest}>
      {message}
    </ErrorMessageBox>
  );
}
